import React, { type FC } from 'react';
import { DashboardFrame } from '@aleph/supergrid';
import classNames from 'classnames';
import { Checkbox, useKeyboardAction } from '@aleph/shared-components';
import { ICellRendererParams } from 'ag-grid-community';

interface IProps extends ICellRendererParams {
	disableSelection?: boolean;
}

const IndexCellRenderer: FC<IProps> = (params) => {
	const [, updateState] = React.useState({});
	const forceUpdate = React.useCallback(() => { updateState({}); }, []);
	const currNode = params.node.isRowPinned() ? params.data.originalNode : params.node;
	const isDashboardView = params.data?.isDashboardView && !params.node.expanded;

	const onToggle = () => {
		currNode.setSelected(!currNode.isSelected());
		forceUpdate();
	};

	useKeyboardAction({
		element: params.eGridCell,
		handler: onToggle,
	});

	const isFocused = params.api.getFocusedCell()?.rowIndex === currNode.rowIndex
        && params.api.getFocusedCell()?.column === params.column;

	const isCreateRow = params.data?.supergridIsCreateRow;

	return (
		<>
			<div data-testid="checkbox"
				className="text-gray-600 font-normal relative flex
			 px-[8px] justify-center items-center h-[64px] max-h-full"
			>
				{currNode.rowIndex + 1}

				{
					!isCreateRow && !params.disableSelection && <Checkbox
						className={classNames({
							'opacity-0 hover:opacity-100': !currNode.isSelected() && !isFocused,
						})}
						onClick={onToggle}
						checked={currNode.isSelected()}
						wrapperClassName="!absolute row-selector-checkbox"
					/>
				}
			</div>
			{isDashboardView && <DashboardFrame />}
		</>
	);
};

export default IndexCellRenderer;
